import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import Stocks1cApi from '../../../API/shipment/stocks1c-api';
import { NavTabs, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button, SendButton } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { Input, Select } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableHeader, TablePagination } from '../../../components/Basic/Table';
import { H1, Text } from '../../../components/Basic/WrapsStyle';
import { IP_LIST, TYPE_BUTTONS } from '../../../constans';
import IpStockLine from './IpStockLine';
import styles from './styles.module.scss';

export const MARKETS_LIST = ['Не выбрана', 'Ozon', 'Wb', 'Yandex', 'Megamarket', 'Avito'];

const MODES = ['Режим отгрузки', 'Режим докупов', 'Честный знак'];
const MODES_OWNER = ['Режим отгрузки', 'Режим докупов', 'Честный знак', 'Финансы'];

export const WIDTH_POSTING = [
  '150px', // 0
  '400px', // 1
  '200px', // 2
  '200px', // 3
  '180px', // 4
  '127px', // 5
  '100px', // 6
  '200px', // 7
  '100px', // 8
  '40px', // 9
  '100px', // 10
  '250px', // 11
  '170px', // 12
  '140px', // 13
  '340px', // 14
];

const FILTER = {
  0: 'all_41',
  1: 'all_45',
  2: 'not_map',
  3: 'double_art',
};

function IpStocks41Page() {
  const user = useSelector((store) => store.user);

  const [postingsPrint, setPostingsPrint] = useState({});

  const [IPSelect, setIPSelect] = useState({ name: 'Не выбран', id: undefined });
  const [count, setCount] = useState([]);
  const [page, setPage] = useState(1);

  const [show, setShow] = useState(20);
  const [search, setSearch] = useState('');

  const [countStock, setCountStock] = useState([0, 0, 0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [provider, changeProvider] = useState({ name: 'Не выбран', id: null });

  const allProviders = useSelector((store) => store.providers);
  const [providers, setProviders] = useState([]);

  const [products, setProducts] = useState({ ids: [], byIds: {}, map: {} });

  const onChangePage = (v) => {
    setPage(v);
  };

  const params = useMemo(() => {
    console.log('IPSelect', IPSelect);
    return {
      limit: parseInt(show),
      page,
      tab: FILTER[tab],
      search: search.trim(),
      providerId: provider.id,
      ip_id: IPSelect.id,
    };
  }, [show, page, search, provider.id, IPSelect.id, tab]);

  const loadData = () => {
    Stocks1cApi.getStocks({ data: params })
      .then((res) => {

        const byIds = {};
        setCountStock([res.tabs.all_41, res.tabs.all_45, res.tabs.not_map, res.tabs.double_art]);
        const ids = res.products.map((item) => item._id);
        res.products.forEach((item) => (byIds[item._id] = item));

        setProducts({ byIds, ids });
        setCount(res.count);
      })
      .catch((err) => {
        console.log(err);
        if (err.code === 140) {
          setError('Не удалось отгрузку');
        }
      });
  };
  const onChangeTab = (n) => {
    setTab(n);
  };

  const clear41 = () => {
    Stocks1cApi.clear({ data: { ip_id: IPSelect.name === 'Не выбран' ? undefined : IPSelect.id } });
  };
  const dereserve41 = () => {
    Stocks1cApi.dereserve({});
  };

  useEffect(() => {
    loadData();
  }, [params]);

  useEffect(() => {
    const p = allProviders.filter((item) => !item.hide);
    if (p.length > 0) {
      setProviders([{ name: 'Не выбран', id: null }, ...p]);
      changeProvider({ name: 'Не выбран', id: null });
    } else {
      changeProvider({ name: '' });
    }
  }, [allProviders]);

  const isOwner = user.role === 'owner' || user.role === 'admin';

  const modes = isOwner ? MODES_OWNER : MODES;

  return (
    <>
      <Content>
        <H1 style={{ marginBottom: '-3px', marginBottom: '20px' }}>Остатки в 1с</H1>

        <WhiteBlock className={styles.search_block}>
          <Row className={styles.navigate_table}>
            <NavTabs
              open_tab={tab}
              tabs={['Остатки 41 счет', 'Остатки 45 счет', 'Без связки с поставщиков', 'Дубли артикулов']}
              isNum={true}
              num={countStock}
              style_tab={styles.style_tab}
              onChange={onChangeTab}
            />
          </Row>

          <Row className={styles.row_input}>
            <Input value={search} onBlur={(v) => setSearch(v)} onClickEnter={(v) => setSearch(v)} label="Поиск" />
          </Row>

          <Text style={{ marginTop: '15px' }}>{`Найдено: ${count}`}</Text>

          <Row style={{ height: '40px', alignItems: 'flex-end', marginTop: '10px' }} spaceBetween={true}>
            <Row style={{ alignItems: 'flex-end' }}>
              <div>
                <Select
                  label="Показать на странице"
                  select={show}
                  list={['20', '50', '100', '150', '200', '500', '1000']}
                  onSelect={(v) => setShow(v)}
                  width="150px"
                  style={{ marginRight: '15px' }}
                />
              </div>
              {tab != 1 && (
                <Select
                  label="Поставщик"
                  select={provider}
                  valueFn={(p) => p.name}
                  list={providers}
                  width="200px"
                  onSelect={(v) => changeProvider(v)}
                  style={{ marginRight: '15px' }}
                />
              )}
              <Select
                label="Контрагент"
                select={IPSelect}
                list={[{ name: 'Не выбран', id: undefined }, ...IP_LIST]}
                valueFn={(ip) => ip?.name}
                width="200px"
                onSelect={(v) => setIPSelect(v)}
                style={{ marginRight: '15px' }}
              />
              {IPSelect === 'Не выбран' ? (
                <Button disabled={true} type={TYPE_BUTTONS.GREEN}>
                  Подгрузить остатки
                </Button>
              ) : (
                <>
                  <SendButton
                    sendApi={Stocks1cApi.uploadExcelStocksPeriod}
                    sendData={{ data: { ip_id: IPSelect.name === 'Не выбран' ? undefined : IPSelect.id } }}
                    style={{ marginRight: '15px' }}
                    disabled={IPSelect === 'Не выбран'}
                  >
                    Подгрузить 41й счет
                  </SendButton>
                  <SendButton
                    sendApi={Stocks1cApi.updloadGTD}
                    sendData={{ data: { ip_id: IPSelect.name === 'Не выбран' ? undefined : IPSelect.id, byPeriod: true } }}
                    style={{ marginRight: '5px' }}
                    disabled={IPSelect === 'Не выбран'}
                  >
                    Подгрузить ГТД за период
                  </SendButton>
                  <SendButton
                    sendApi={Stocks1cApi.saveNds}
                    sendData={{}}
                    style={{ marginRight: '5px' }}
                  >
                    Подгрузить НДС
                  </SendButton>
                </>
              )}

              <Button
                type={TYPE_BUTTONS.WHITE}
                onClick={() =>
                  Stocks1cApi.excelStocks({
                    data: {
                      ...params,
                      limit: undefined,
                      page: undefined,
                      sortType: undefined,
                      type: 'xlsx',
                      ip_id: IPSelect.name === 'Не выбран' ? undefined : IPSelect.id,
                    }
                  })
                }
                style={{ marginLeft: '10px', background: 'rgb(250 255 42 / 58%)' }}
              >
                Выгрузка в xlsx
              </Button>
              <Button
                type={TYPE_BUTTONS.WHITE}
                onClick={() =>

                  Stocks1cApi.excelStocks({
                    data: {
                      ...params,
                      limit: undefined,
                      page: undefined,
                      sortType: undefined,
                      type: 'xml',
                      ip_id: IPSelect.name === 'Не выбран' ? undefined : IPSelect.id,
                    }
                  })
                }
                style={{ marginLeft: '10px', background: 'rgb(250 255 42 / 58%)' }}
              >
                Выгрузка в xml
              </Button>
            </Row>

            <Row>
              <Button type={TYPE_BUTTONS.RED} onClick={dereserve41} style={{ marginRight: '15px' }}>
                Дерезервировать
              </Button>
              <Button type={TYPE_BUTTONS.RED} onClick={clear41}>
                Очистить
              </Button>
            </Row>
          </Row>
        </WhiteBlock>
        <Table styles={styles.table}>
          <TableHeader whiteHeader>
            <HeaderTitle width={WIDTH_POSTING[0]}>Артикул 1с</HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[0]}>Артикул</HeaderTitle>

            <HeaderTitle width={WIDTH_POSTING[1]} centerText={true}>
              Наименование
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[13]} centerText={true}>
              Остаток
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[13]} centerText={true}>
              Заререзвировано на реализацию
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[13]} centerText={true}>
              Доступное <br />
              кол-во
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
              Контрагент
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
              Поставщик
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
              Средняя цена без НДС / c НДС
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
              Ставка НДС
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
              Штрихкод
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[14]} centerText={true}>
              ГТД
            </HeaderTitle>

          </TableHeader>
          {products.ids.map((product, id) => {
            return <IpStockLine key={`${product._id}-${id}`} product={products.byIds[product]} />;
          })}
        </Table>

        <TablePagination num={Math.ceil(count / show) || 1} show={page} onChange={onChangePage} />
      </Content>
    </>
  );
}

export default IpStocks41Page;
